import React, { memo, useEffect, useState } from 'react';

import { Steps, Col, Row } from 'antd';

import './style.css';

export interface StepsInterface {
  title: string;
  current?: number;
  status?: string | undefined;
  steps: StepInterface[];
}

export interface StepInterface {
  id?: string;
  step: number;
  title: string;
  description?: string;
  content: JSX.Element;
}

interface Props {
  activeStep: number;
  legend: string | undefined;
  DemandaForm?: () => JSX.Element;
  steps: StepsInterface[];
  direction?: 'vertical' | 'horizontal';
}

interface ConfigStep {
  stepsWidth: string;
  stepSpan: number;
  stepContentSpan: number;
}

function StepPanel({ steps: stepsInputs, activeStep, DemandaForm, legend, direction = 'vertical' }: Props) {
  const [config, setConfig] = useState<ConfigStep>({
    stepsWidth: '300px',
    stepSpan: 6,
    stepContentSpan: 18,
  });

  useEffect(() => {
    if (direction === 'horizontal') {
      setConfig({
        stepsWidth: '100%',
        stepSpan: 24,
        stepContentSpan: 24,
      });
    }
  }, [direction]);

  let currentStepPanel = 0;
  let currentStep = 0;

  stepsInputs.forEach((steps, indexPanel) => {
    let indexStep = steps.steps.findIndex(step => step.step === activeStep);
    if (indexStep >= 0) {
      currentStep = indexStep;
      currentStepPanel = indexPanel;
    }
  });

  const renderSteps = (steps: StepsInterface, index: number) => (
    <Steps
      initial={steps.steps[0].step - 1}
      key={index.toString() + steps.title}
      current={activeStep - 1}
      size="small"
      style={{ maxWidth: config.stepsWidth }}
      direction={direction}>
      {steps.steps.map((item, idx) => (
        <Steps.Step key={idx.toString() + item.title} title={item.title} description={item.description} />
      ))}
    </Steps>
  );

  return (
    <>
      {stepsInputs.length > 0 && (
        <Row gutter={24}>
          <Col span={config.stepSpan}>
            {stepsInputs.map((steps, index) =>
              steps.title ? (
                <fieldset key={steps.title}>
                  <legend>{steps.title}</legend>
                  {renderSteps(steps, index)}
                </fieldset>
              ) : (
                renderSteps(steps, index)
              ),
            )}
          </Col>
          <Col span={config.stepContentSpan}>
            {DemandaForm && <DemandaForm />}

            {legend ? (
              <fieldset>
                <legend>{legend}</legend>
                {stepsInputs[currentStepPanel].steps[currentStep].content}
              </fieldset>
            ) : (
              <>{stepsInputs[currentStepPanel].steps[currentStep].content}</>
            )}
          </Col>
        </Row>
      )}
    </>
  );
}

export default memo(StepPanel);
